import { C, MONO, STAGE_COLORS, Eyebrow } from "./hubShared";

export const HubFunnel = ({ funnel, total, active, onPick }) => (
  <div data-testid="hub-funnel">
    <Eyebrow>Activation funnel · click a stage to see who is stuck there</Eyebrow>
    <div className="hub-funnel-row" style={{ display: "grid", gridTemplateColumns: `repeat(${funnel.length}, minmax(0, 1fr))`, gap: 8, marginTop: 10 }}>
      {funnel.map((s, i) => {
        const raw = total ? (s.reached / total) * 100 : 0;
        const pct = raw > 0 && raw < 1 ? raw.toFixed(1) : Math.round(raw);
        const first = s.stage === "not_contacted";
        const on = active === s.stage;
        return (
          <button key={s.stage} onClick={() => onPick(on ? "" : s.stage)} data-testid={`hub-funnel-${s.stage}`}
            className="hub-card"
            style={{ textAlign: "left", padding: "14px 14px 12px", background: on ? C.navy : "#fff", color: on ? "#fff" : C.ink,
              border: `1px solid ${on ? C.navy : "rgba(26,30,36,0.10)"}`, borderRadius: 10, cursor: "pointer",
              animationDelay: `${i * 40}ms`, position: "relative", overflow: "hidden" }}>
            <div style={{ fontSize: 11, fontWeight: 600, opacity: on ? 0.85 : 0.7, lineHeight: 1.25, minHeight: 28 }}>{first ? "All members" : s.label}</div>
            <div style={{ fontFamily: MONO, fontWeight: 700, fontSize: 26, marginTop: 6, fontVariantNumeric: "tabular-nums" }} data-testid={`hub-funnel-${s.stage}-reached`}>{s.reached}</div>
            <div style={{ fontFamily: MONO, fontSize: 10.5, opacity: 0.7, marginTop: 2 }}>{first ? "" : `${pct}% reached · `}<b data-testid={`hub-funnel-${s.stage}-stuck`}>{s.stuck}</b> {first ? "not contacted yet" : "here"}</div>
            <div style={{ position: "absolute", left: 0, bottom: 0, height: 3, width: `${pct}%`, background: STAGE_COLORS[s.stage], transition: "width 0.5s ease" }} />
          </button>
        );
      })}
    </div>
  </div>
);
